// RitualAura — scripts propios (vanilla, sin librerias externas)

function raInitReveal() {
  var els = document.querySelectorAll('.ra-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('ra-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('ra-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { obs.observe(el); });

  setTimeout(function () {
    els.forEach(function (el) {
      if (el.classList.contains('ra-visible')) return;
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        el.classList.add('ra-visible');
      }
    });
  }, 400);
}

function raInitComparador() {
  document.querySelectorAll('[data-ra-comparador]').forEach(function (comp) {
    var input = comp.querySelector('[data-ra-comparador-input]');
    var antes = comp.querySelector('[data-ra-comparador-antes]');
    var linea = comp.querySelector('[data-ra-comparador-linea]');
    if (!input || !antes) return;
    function actualizar() {
      var v = input.value;
      antes.style.clipPath = 'inset(0 ' + (100 - v) + '% 0 0)';
      if (linea) linea.style.left = v + '%';
    }
    input.addEventListener('input', actualizar);
    actualizar();
  });
}

function raInitGaleria() {
  var galerias = document.querySelectorAll('[data-ra-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-ra-galeria-principal]');
    var minis = galeria.querySelectorAll('[data-ra-galeria-mini]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var full = mini.getAttribute('data-full');
        if (!full) return;
        principal.src = full;
        minis.forEach(function (m) { m.classList.remove('is-activa'); });
        mini.classList.add('is-activa');
      });
    });
  });
}

function raNormalizar(valor) {
  return (valor || '').toString().trim().toLowerCase();
}

function raEscaparAtributo(valor) {
  if (window.CSS && typeof CSS.escape === 'function') return CSS.escape(valor);
  return (valor || '').replace(/["\\]/g, '\\$&');
}

function raInitVariantes() {
  var forms = document.querySelectorAll('[data-ra-producto-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-ra-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var pills = form.querySelectorAll('[data-ra-opcion-valor]');
    var idInput = form.querySelector('[data-ra-variant-id]');
    // El precio y el aviso de stock viven fuera del <form> (son hermanos
    // dentro de .ra-compra), no dentro de él. Por eso se buscan desde el
    // contenedor .ra-compra y no desde el propio form.
    var contenedorCompra = form.closest('.ra-compra') || form.parentElement || form;
    var precioEl = contenedorCompra.querySelector('[data-ra-precio]');
    var precioAntesEl = contenedorCompra.querySelector('[data-ra-precio-antes]');
    var btn = form.querySelector('[data-ra-btn-comprar]');
    var agotadoMsg = form.querySelector('[data-ra-agotado]');
    var galeria = form.closest('.ra-producto') && form.closest('.ra-producto').querySelector('[data-ra-galeria]');
    var principal = galeria && galeria.querySelector('[data-ra-galeria-principal]');
    var minis = galeria ? galeria.querySelectorAll('[data-ra-galeria-mini]') : [];
    var imagenDefecto = galeria ? galeria.getAttribute('data-imagen-defecto') : '';

    var stockWrap = contenedorCompra.querySelector('[data-ra-stock-wrap]');
    var stockBajoEl = stockWrap && stockWrap.querySelector('[data-ra-stock-bajo]');
    var stockBajoTextoEl = stockBajoEl && stockBajoEl.querySelector('[data-ra-stock-bajo-texto]');
    var stockOkEl = stockWrap && stockWrap.querySelector('[data-ra-stock-ok]');
    var stockUmbral = stockWrap ? parseInt(stockWrap.getAttribute('data-umbral'), 10) || 0 : 0;
    var stockPlantillaBajo = stockWrap ? (stockWrap.getAttribute('data-texto-bajo') || '') : '';

    function seleccionActual() {
      var seleccion = {};
      form.querySelectorAll('[data-ra-opcion-valor].is-activa').forEach(function (p) {
        seleccion[raNormalizar(p.getAttribute('data-ra-opcion-nombre'))] = raNormalizar(p.getAttribute('data-ra-opcion-valor'));
      });
      return seleccion;
    }

    function buscarVariante() {
      var seleccion = seleccionActual();
      return variantes.find(function (v) {
        return v.optionValues.every(function (val, i) {
          return seleccion[raNormalizar(v.optionNames[i])] === raNormalizar(val);
        });
      });
    }

    function actualizarImagen(variante) {
      if (!principal) return;
      var destino = variante.image || imagenDefecto;
      if (!destino) return;
      principal.src = destino;
      var coincide = false;
      minis.forEach(function (m) {
        var esEsta = m.getAttribute('data-full') === destino;
        m.classList.toggle('is-activa', esEsta);
        if (esEsta) coincide = true;
      });
      if (!coincide) minis.forEach(function (m) { m.classList.remove('is-activa'); });
    }

    function actualizarStock(variante) {
      if (!stockWrap) return;
      if (stockBajoEl) stockBajoEl.style.display = 'none';
      if (stockOkEl) stockOkEl.style.display = 'none';
      if (variante.inventoryManagement !== 'shopify') return;
      var qty = variante.inventoryQuantity;
      if (qty > 0 && qty <= stockUmbral) {
        if (stockBajoEl) {
          stockBajoEl.style.display = '';
          if (stockBajoTextoEl) stockBajoTextoEl.textContent = stockPlantillaBajo.replace('[cantidad]', qty);
        }
      } else if (qty > 0) {
        if (stockOkEl) stockOkEl.style.display = '';
      }
    }

    function actualizar() {
      var variante = buscarVariante();

      // Seguridad: si por cualquier motivo no se encuentra una variante que
      // coincida exactamente con la selección visible, se bloquea la compra
      // en lugar de dejar un id de variante desactualizado (que cobraría un
      // precio distinto al que el cliente ve en pantalla).
      if (!variante) {
        if (idInput) idInput.value = '';
        if (btn) {
          btn.disabled = true;
          var txt = btn.querySelector('[data-ra-btn-texto]');
          if (txt) txt.textContent = 'Selecciona una opción';
        }
        return;
      }

      if (idInput) idInput.value = variante.id;
      // El precio siempre se toma ya formateado desde Liquid (filtro `money`
      // del propio tema), nunca se reformatea en JS: así coincide siempre,
      // carácter por carácter, con el precio inicial renderizado por el
      // servidor y respeta la moneda real de la tienda sin depender de que
      // `window.Shopify.currency` exista en la página.
      if (precioEl) precioEl.textContent = variante.priceFormatted;
      if (precioAntesEl) {
        if (variante.compareAtPriceFormatted) {
          precioAntesEl.textContent = variante.compareAtPriceFormatted;
          precioAntesEl.style.display = '';
        } else {
          precioAntesEl.style.display = 'none';
        }
      }
      if (btn) {
        btn.disabled = !variante.available;
        var txt = btn.querySelector('[data-ra-btn-texto]');
        if (txt) txt.textContent = variante.available ? btn.getAttribute('data-texto-disponible') : btn.getAttribute('data-texto-agotado');
      }
      if (agotadoMsg) agotadoMsg.style.display = variante.available ? 'none' : '';
      actualizarImagen(variante);
      actualizarStock(variante);
    }

    function activarPillsDeVariante(variante) {
      variante.optionValues.forEach(function (val, i) {
        var nombre = variante.optionNames[i];
        form.querySelectorAll('[data-ra-opcion-nombre="' + raEscaparAtributo(nombre) + '"]').forEach(function (p) {
          var esEsta = raNormalizar(p.getAttribute('data-ra-opcion-valor')) === raNormalizar(val);
          p.classList.toggle('is-activa', esEsta);
          p.setAttribute('aria-pressed', esEsta ? 'true' : 'false');
        });
      });
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var grupo = pill.getAttribute('data-ra-opcion-nombre');
        form.querySelectorAll('[data-ra-opcion-nombre="' + raEscaparAtributo(grupo) + '"]').forEach(function (p) {
          p.classList.remove('is-activa');
          p.setAttribute('aria-pressed', 'false');
        });
        pill.classList.add('is-activa');
        pill.setAttribute('aria-pressed', 'true');
        actualizar();
      });
    });

    // Sincronización inversa: si el cliente toca una miniatura de la galería,
    // se selecciona automáticamente la variante (color/opción) a la que
    // pertenece esa foto, y se actualizan precio y botón de compra igual
    // que si hubiera tocado el selector de opciones.
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var full = mini.getAttribute('data-full');
        if (!full) return;
        var variante = variantes.find(function (v) { return v.image === full; });
        if (!variante) return;
        activarPillsDeVariante(variante);
        actualizar();
      });
    });

    actualizar();
  });
}

function raInitCatalogoFiltros() {
  document.querySelectorAll('[data-ra-catalogo-grid]').forEach(function (grid) {
    var contenedor = grid.closest('.ra-catalogo');
    if (!contenedor) return;
    var filtros = contenedor.querySelectorAll('[data-ra-filtro]');
    var tarjetas = grid.querySelectorAll('.ra-catalogo__card');
    if (!filtros.length) return;
    filtros.forEach(function (filtro) {
      filtro.addEventListener('click', function () {
        var valor = filtro.getAttribute('data-ra-filtro');
        filtros.forEach(function (f) { f.classList.remove('is-activo'); });
        filtro.classList.add('is-activo');
        tarjetas.forEach(function (tarjeta) {
          var categoria = tarjeta.getAttribute('data-ra-categoria');
          var mostrar = valor === 'todos' || categoria === valor;
          tarjeta.classList.toggle('ra-oculta', !mostrar);
        });
      });
    });
  });
}

function raInitBurbuja() {
  document.querySelectorAll('[data-ra-burbuja]').forEach(function (burbuja) {
    var id = burbuja.getAttribute('data-ra-burbuja-id');
    var storageKey = 'ra-burbuja-cerrada-' + id;
    try {
      if (sessionStorage.getItem(storageKey)) return;
    } catch (e) {}

    var retraso = parseInt(burbuja.getAttribute('data-ra-burbuja-retraso'), 10) || 0;
    var timer = setTimeout(function () {
      burbuja.classList.add('is-visible');
    }, retraso);

    var cerrar = burbuja.querySelector('[data-ra-burbuja-cerrar]');
    if (cerrar) {
      cerrar.addEventListener('click', function (e) {
        e.preventDefault();
        clearTimeout(timer);
        burbuja.classList.remove('is-visible');
        try { sessionStorage.setItem(storageKey, '1'); } catch (e) {}
      });
    }
  });
}

function raInitAudioAmbiente() {
  var contenedor = document.querySelector('[data-ra-audio-ambiente]');
  if (!contenedor) return;
  var audio = contenedor.querySelector('[data-ra-audio-elemento]');
  var boton = contenedor.querySelector('[data-ra-audio-boton]');
  var sliderVolumen = contenedor.querySelector('[data-ra-audio-volumen]');
  if (!audio || !boton) return;

  var CLAVE_ACTIVO = 'ra-audio-activo';
  var CLAVE_VOLUMEN = 'ra-audio-volumen';
  var CLAVE_TIEMPO = 'ra-audio-tiempo';

  audio.addEventListener('timeupdate', function () {
    try { localStorage.setItem(CLAVE_TIEMPO, audio.currentTime); } catch (e) {}
  });

  function retomarPosicion(despues) {
    var tiempoGuardado = parseFloat(localStorage.getItem(CLAVE_TIEMPO));
    if (isNaN(tiempoGuardado) || tiempoGuardado <= 0) {
      despues();
      return;
    }
    if (audio.readyState >= 1) {
      try { audio.currentTime = tiempoGuardado; } catch (e) {}
      despues();
    } else {
      audio.addEventListener('loadedmetadata', function alListo() {
        audio.removeEventListener('loadedmetadata', alListo);
        try { audio.currentTime = tiempoGuardado; } catch (e) {}
        despues();
      });
      audio.load();
    }
  }

  var volumenDefault = parseInt(contenedor.getAttribute('data-volumen'), 10);
  var volumenGuardado = parseInt(localStorage.getItem(CLAVE_VOLUMEN), 10);
  var volumenObjetivo = (!isNaN(volumenGuardado) ? volumenGuardado : (isNaN(volumenDefault) ? 18 : volumenDefault)) / 100;

  if (sliderVolumen) sliderVolumen.value = Math.round(volumenObjetivo * 100);
  audio.volume = 0;

  var fadeFrame = null;
  function fadeVolumen(destino, duracionMs, alTerminar) {
    if (fadeFrame) cancelAnimationFrame(fadeFrame);
    var inicio = audio.volume;
    var t0 = performance.now();
    function paso(ahora) {
      var progreso = Math.min((ahora - t0) / duracionMs, 1);
      audio.volume = inicio + (destino - inicio) * progreso;
      if (progreso < 1) {
        fadeFrame = requestAnimationFrame(paso);
      } else if (typeof alTerminar === 'function') {
        alTerminar();
      }
    }
    fadeFrame = requestAnimationFrame(paso);
  }

  function marcarReproduciendo(activo) {
    boton.classList.toggle('is-reproduciendo', activo);
    boton.setAttribute('aria-pressed', activo ? 'true' : 'false');
  }

  function reproducir(esResumenAutomatico) {
    retomarPosicion(function () {
      audio.volume = 0;
      var promesa = audio.play();

      function alExito() {
        marcarReproduciendo(true);
        fadeVolumen(volumenObjetivo, 2500);
        try { localStorage.setItem(CLAVE_ACTIVO, '1'); } catch (e) {}
      }

      function alFallo() {
        marcarReproduciendo(false);
        if (esResumenAutomatico) {
          var reintentar = function () {
            reproducir(false);
          };
          document.addEventListener('click', reintentar, { once: true, passive: true });
          document.addEventListener('touchstart', reintentar, { once: true, passive: true });
        }
      }

      if (promesa && promesa.then) {
        promesa.then(alExito).catch(alFallo);
      } else {
        alExito();
      }
    });
  }

  function pausar() {
    fadeVolumen(0, 600, function () {
      audio.pause();
    });
    marcarReproduciendo(false);
    try { localStorage.setItem(CLAVE_ACTIVO, '0'); } catch (e) {}
  }

  boton.addEventListener('click', function () {
    if (audio.paused) {
      reproducir(false);
    } else {
      pausar();
    }
  });

  if (sliderVolumen) {
    sliderVolumen.addEventListener('input', function () {
      volumenObjetivo = parseInt(sliderVolumen.value, 10) / 100;
      try { localStorage.setItem(CLAVE_VOLUMEN, sliderVolumen.value); } catch (e) {}
      if (!audio.paused) audio.volume = volumenObjetivo;
    });
  }

  reproducir(true);
}

document.addEventListener('DOMContentLoaded', function () {
  raInitReveal();
  raInitGaleria();
  raInitVariantes();
  raInitComparador();
  raInitCatalogoFiltros();
  raInitBurbuja();
  raInitAudioAmbiente();
});
